import Head from 'next/head'
import { ReactNode } from 'react'
import { RankType } from '@/api/workspaces-api'
import Layout from '@/components/billboard/layout'
import Top100Page from '@/components/billboard/top100'
import { defaultTitlePrefix } from '@/constants/landing/default-meta-info'
import { NextLayoutComponentType } from '@/types/next-layout-component-type'
import { platformShortcodeSchema } from '@/types/schema/platform/platform-shortcode-schema'

const FacebookCommunityVolumePage: NextLayoutComponentType = () => {
  return (
    <>
      <Head>
        <title>
          {defaultTitlePrefix}
          最新！台灣 TOP 100 Facebook 帳號口碑聲量排行榜
        </title>
        <meta
          content='全球最大的 AI 網紅資料庫 Kolr，重磅推出「台灣百大 Facebook 帳號口碑聲量排行榜」！榜單使用 AI 即時統計、分析台灣 FB 網紅與品牌等帳號的互動成效，綜合計算貼文按讚、留言、分享數等數據，推出最全面的台灣 FB 口碑聲量榜單。'
          name='description'
        />
      </Head>
      <Top100Page
        aboutList={[
          '榜單更新時間：每 2 週自動更新',
          'Facebook 帳號評選條件：帳號粉絲數超過 1 萬人',
          '口碑聲量公式：平均按讚數 * 單次按讚價值 + 平均留言數 * 單次留言價值 + 平均分享數 * 單次分享價值',
        ]}
        description='透過亞太最大的 AI 網紅資料庫 Kolr，即時爬梳、統計所有台灣 Facebook 網紅與品牌等帳號的社群口碑聲量，並排序出 TOP 100 台灣 Facebook 帳號的口碑聲量排行榜。'
        platform={platformShortcodeSchema.enum.fb}
        rankType={RankType.WordOfMouthVolume}
        title='台灣 TOP 100 Facebook 帳號口碑聲量排行榜'
      />
    </>
  )
}

FacebookCommunityVolumePage.getLayout = (page): ReactNode => {
  return <Layout>{page}</Layout>
}

export default FacebookCommunityVolumePage
